import React from "react";
import "react-bootstrap/dist/react-bootstrap.min.js";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { store } from "../redux/store";
import { Provider } from "react-redux";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from "../lib/queryClient";
import Home from "./Components/Home";

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={'/'}>
          <Switch>
            <Route path="*" component={Home} />
          </Switch>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;